<template>
  <div class="problemDesContent">
    <el-collapse v-model="activeNames">
      <el-collapse-item name="des">
        <template #title>
          <span>
            <img src="../../assets/svg/desIcon.svg" alt="" />
            问题描述
          </span>
        </template>
        <el-form :model="form" :rules="formRules" ref="descForm">
          <el-descriptions :column="3" border>
            <el-descriptions-item :span="6" v-bind="baseClassConfig">
              <template slot="label">
                <div class="labelDetail">
                  <p>故障现象描述</p>
                  <div>
                    <translate
                      :content="form.questionContent"
                      field="questionContentCh"
                      @getTranslateVal="
                        (field, value) => {
                          this.$set(form, field, value);
                        }
                      "
                    />
                  </div>
                </div>
              </template>
              <div
                class="translateDetail"
                style="border-bottom: 1px solid var(--table-color) !important"
              >
                <el-form-item prop="questionContent" v-if="!authStatus">
                  <el-input
                    :disabled="authStatus"
                    @blur="inputBlur(form.questionContent, 'questionContent')"
                    v-model="form.questionContent"
                    type="textarea"
                    placeholder="请输入故障现象描述"
                  />
                </el-form-item>
                <div v-else class="leftForm problemDesInfo">
                  {{ form.questionContent }}
                </div>
                <div class="problemDesInfo">{{ form.questionContentCh }}</div>
              </div>
            </el-descriptions-item>
          </el-descriptions>
          <!-- 客户诉求 -->
          <el-descriptions :column="3" border>
            <el-descriptions-item label="客户诉求" v-bind="authStatus ? '' : otherClassName">
              <el-form-item prop="customerDemand" v-if="!authStatus">
                <el-input
                  v-model="form.customerDemand"
                  :disabled="authStatus"
                  type="textarea"
                  :autosize="{ minRows: 2, maxRows: 2 }"
                  placeholder="请输入客户诉求"
                  @blur="inputBlur(form.customerDemand, 'customerDemand')"
                  maxlength="500"
                  show-word-limit
                ></el-input>
              </el-form-item>
              <div v-else>{{form.customerDemand}}</div>
            </el-descriptions-item>
          </el-descriptions>
          <!-- 临时措施 -->
          <el-descriptions
            :column="3"
            border
            v-if="form.temporaryMeasure?.solution.length > 0"
          >
            <el-descriptions-item
              :span="6"
              label="临时措施"
              v-bind="measureClassName"
              >{{ form.temporaryMeasure.solution }}</el-descriptions-item
            >
          </el-descriptions>
          <!-- 根因分析 -->
          <div v-if="form.rootCauseAnalysis?.length > 0">
            <div class="labelDetail">
              <p>根因分析</p>
            </div>
            <el-table
              style="width: 100%"
              ref="tableRef"
              border
              stripe
              :data="form.rootCauseAnalysis"
              class="rootCauseAnalysisTable"
            >
              <el-table-column
                label="序号"
                width="50px"
                type="index"
                align="center"
              >
              </el-table-column>
              <el-table-column label="根因分析" prop="solution">
              </el-table-column>
              <el-table-column label="附件" prop="fileData">
                <template slot-scope="{ row }">
                  <file-upload-list
                    ref="fileUploadList"
                    :fileList="row.fileData"
                  ></file-upload-list>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <!-- 永久方案 -->
          <div v-if="form.permanentSolution?.length > 0">
            <div class="labelDetail">
                  <p>永久方案</p>
                </div>
                <el-table
                   style="width: 100%"
                ref="tableRef"
                :border="true"
                stripe
                :data="form.permanentSolution"
                class="permanentSolutionTable"
              >
                <el-table-column
                  label="序号"
                  width="50px"
                  type="index"
                  align="center"
                >
                </el-table-column>
                <el-table-column label="永久方案" prop="solution">
                </el-table-column>
                <el-table-column label="附件" prop="fileData">
                  <template slot-scope="{ row }">
                    <file-upload-list
                      ref="fileUploadList"
                      :fileList="row.fileData"
                    ></file-upload-list>
                  </template>
                </el-table-column>
              </el-table>
          </div>
        </el-form>
        <!-- <el-descriptions :column="3" border>
          <el-descriptions-item label="附件" :span="6">
            <file-upload-list ref="fileUploadList" :fileList="problemDes.questionDescriptionAndFiles.faultDescriptionList"></file-upload-list>
          </el-descriptions-item>
        </el-descriptions> -->
      </el-collapse-item>
    </el-collapse>
  </div>
</template>
<script>
import Translate from "@/components/translate";
import fileUploadTips from "@/components/fileUpload/fileUploadTips.vue";

export default {
  name: "problemDes",
  components: { Translate, fileUploadTips },
  data() {
    return {
      activeNames: ["des"], // 全部展开
      form: {},
    };
  },
  props: {
    problemDes: {
      type: [Array, Object],
      // default:() => []
    },
    authStatus: {
      type: Boolean,
    },
  },
  computed: {
    formRules() {
      const isRequired = !this.authStatus;
      return {
        questionContent: [
          {
            required: isRequired,
            message: "故障现象描述不能为空",
            trigger: ["blur", "change"],
          },
        ],
        customerDemand: [
          { required: isRequired, message: "请输入客户诉求", trigger: "blur" },
        ],
      };
    },
    // 翻译
    baseClassConfig() {
      return {
        labelClassName: `translate-label ${
          this.authStatus ? "" : "lable-required"
        }`,
        contentClassName: "translate-content",
      };
    },
    otherClassName() {
      return {
        labelClassName:
          this.authStatus && this.editStatus
            ? " top-none"
            : "lable-required top-none",
        contentClassName: "content-input top-none",
      };
    },
    measureClassName() {
      return {
        labelClassName:
          this.problemDes.rootCauseAnalysis?.length > 0
            ? "top-none"
            : "top-none",
        contentClassName:
          this.problemDes.rootCauseAnalysis?.length > 0
            ? " top-none"
            : "top-none",
      };
    },
    contentClassName() {
      return {
        labelClassName: `transparent-label`,
        contentClassName: `descriptions-content`,
      };
    },
  },
  async created() {
    this.getProblemDesData();
  },
  methods: {
    // 获取数据
    getProblemDesData() {
      console.log(this.problemDes);
      if (this.problemDes) {
        this.form = this.problemDes;
      }
    },
    // 监听失去焦点
    inputBlur(val, type) {
      this.form[type] = val;
      this.$emit("update:problemDes", this.form);
    },
    validateForm() {
      if (!this.$refs["descForm"]) {
        return Promise.resolve({ isValid: true, object: null });
      }
      return this.$refs["descForm"]
        .validate()
        .then(() => ({ isValid: true, object: null }))
        .catch((errors) => ({ isValid: false, object: errors }));
    },
  },
};
</script>
<style scoped>
::v-deep .el-table.rootCauseAnalysisTable .el-table__cell .cell,
::v-deep .el-table.permanentSolutionTable .el-table__cell .cell {
  white-space: normal;
  word-break: break-word;
}
/* ::v-deep .problemContainer .el-descriptions .is-bordered .el-descriptions-item__cell.content-input {

} */
.problemContainer .problemDesContent .content-input .el-textarea {
  width: 100% !important;
}
.problemContainer
  .problemDesContent
  .content-input
  .el-textarea
  ::v-deep
  .el-textarea__inner {
  border-color: transparent;
  border-radius: 0;
}
.problemContainer
  .problemDesContent
  .content-input
  .el-form-item.is-error
  .el-textarea
  ::v-deep
  .el-textarea__inner {
  border-color: #f56c6c;
}
</style>
